import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "actions", "children", "hoverable"];
import "core-js/modules/es6.array.map.js";
import * as React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import omit from 'rc-util/lib/omit';
import Grid from './Grid';
import { Row, Col } from '../../wui-layout/src';
import { ConfigContext } from './config-provider';

function getAction(actions) {
  var actionList = actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement("li", {
      style: {
        width: "".concat(100 / actions.length, "%")
      },
      key: "action-".concat(index)
    }, /*#__PURE__*/React.createElement("span", null, action));
  });
  return actionList;
}

var propTypes = {
  title: PropTypes.element,
  extra: PropTypes.element,
  bordered: PropTypes.bool,
  headStyle: PropTypes.object,
  bodyStyle: PropTypes.object,
  style: PropTypes.object,
  loading: PropTypes.bool,
  hoverable: PropTypes.bool,
  children: PropTypes.element,
  id: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['default', 'small']),
  type: PropTypes.oneOf(['inner']),
  actions: PropTypes.node
};
var defaultProps = {
  headStyle: {},
  bodyStyle: {},
  style: {},
  title: "",
  loading: false,
  bordered: true,
  size: 'default',
  children: '',
  hoverable: false
};

var Card = function Card(props) {
  var _classNames;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls; // const size = React.useContext(SizeContext);
  // const onTabChange = (key) => {
  //   props.onTabChange && props.onTabChange(key);
  // };


  var isContainGrid = function isContainGrid() {
    var containGrid;
    React.Children.forEach(props.children, function (element) {
      if (element && element.type && element.type === Grid) {
        containGrid = true;
      }
    });
    return containGrid;
  };

  var className = props.className,
      extra = props.extra,
      headStyle = props.headStyle,
      bodyStyle = props.bodyStyle,
      title = props.title,
      loading = props.loading,
      _props$bordered = props.bordered,
      bordered = _props$bordered === void 0 ? true : _props$bordered,
      size = props.size,
      type = props.type,
      actions = props.actions,
      children = props.children,
      hoverable = props.hoverable,
      others = _objectWithoutProperties(props, _excluded);

  var prefixCls = getPrefixCls('card');
  var loadingBlockStyle = bodyStyle.padding === 0 || bodyStyle.padding === '0px' ? {
    padding: 24
  } : undefined;
  var block = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-loading-block")
  });
  var loadingBlock = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-loading-content"),
    style: loadingBlockStyle
  }, /*#__PURE__*/React.createElement(Row, {
    gutter: 8
  }, /*#__PURE__*/React.createElement(Col, {
    span: 22
  }, block)), /*#__PURE__*/React.createElement(Row, {
    gutter: 8
  }, /*#__PURE__*/React.createElement(Col, {
    span: 8
  }, block), /*#__PURE__*/React.createElement(Col, {
    span: 15
  }, block)), /*#__PURE__*/React.createElement(Row, {
    gutter: 8
  }, /*#__PURE__*/React.createElement(Col, {
    span: 6
  }, block), /*#__PURE__*/React.createElement(Col, {
    span: 18
  }, block)), /*#__PURE__*/React.createElement(Row, {
    gutter: 8
  }, /*#__PURE__*/React.createElement(Col, {
    span: 13
  }, block), /*#__PURE__*/React.createElement(Col, {
    span: 9
  }, block)), /*#__PURE__*/React.createElement(Row, {
    gutter: 8
  }, /*#__PURE__*/React.createElement(Col, {
    span: 4
  }, block), /*#__PURE__*/React.createElement(Col, {
    span: 3
  }, block), /*#__PURE__*/React.createElement(Col, {
    span: 16
  }, block)));
  var head;

  if (title || extra) {
    head = /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-head"),
      style: headStyle
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-head-wrapper")
    }, title && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-head-title")
    }, title), extra && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-extra")
    }, extra)));
  }

  var body = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle
  }, loading ? loadingBlock : children);
  var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefixCls, "-actions")
  }, getAction(actions)) : null;
  var divProps = omit(others, ['onTabChange']);
  var mergedSize = size;
  var classString = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-hoverable"), hoverable), _defineProperty(_classNames, "".concat(prefixCls, "-contain-grid"), isContainGrid()), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), _defineProperty(_classNames, "".concat(prefixCls, "-type-").concat(type), !!type), _classNames), className);
  return /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
    className: classString
  }), head, body, actionDom);
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
Card.Grid = Grid; // Card.Meta = Meta;

export default Card;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-card/src/index.js